import styled from "styled-components";

export const StyledDisplayCheckListPanel = styled.div``;